import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
import ListLayout from "@/components_v3/layout/ListLayout.vue";
import DownloadButton from "@/components-UI/buttons/DownloadButton.vue";
import ReloadButton from "@/components-UI/buttons/ReloadButton.vue";
import { EventTraceFilters, useEventTracer } from "@/services/TablePage/eventTracer";
import { FormattedItem } from "@/utils/CellsFromBff";
import { EventTrace } from "@/api/types/event-tracer";
import { getEventTraces } from "@/api/event-tracer";
import { downloadExcelFile, showServerError } from "@/utils";
import BaseTable from "@/components-UI/table/BaseTable.vue";
import store from "@/store";
import EventTracerConstructor from "@/components/statistics/event-tracer/EventTracerConstructor.vue";
import { useRoute } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'EventTracerList',
  setup(__props) {

const { getHeaders } = useEventTracer();
const items = ref<FormattedItem<EventTrace>[]>([]);
const total = ref(0);
const offset = ref(0);
const isLoading = ref(false);
const constructor = ref(null);
const tableComp = ref(null);
const filterClass = new EventTraceFilters();
const route = useRoute();

onMounted(() => {
    if (!isDisableGetReport.value) {
        getReport();
    }
});

const isDisableGetReport = computed(() => {
    const dateFrom = route.query.event_date_from;
    const dateTo = route.query.event_date_to;
    return !dateFrom || !dateTo;
});

const getReport = async () => {
    try {
        isLoading.value = true;
        const params = getParams();
        const { data, meta } = await getEventTraces(params);
        items.value = data;
        total.value = meta?.total!;
    } catch (err) {
        showServerError(err, 'Список постбеков не загружен');
    } finally {
        isLoading.value = false;
    }
};

const getParams = (isExport = false) => {
    const rawFilters = { ...store.getters['GET_FILTERS_PARAMS_OBJECT'] };
    const columns = (constructor?.value?.selected! || route.query.columns) as (keyof EventTrace)[];
    const filters = filterClass.prepareFiltersForSend(rawFilters);
    if (isExport) return { filters, columns };
    const paging = { limit: 100, offset: offset.value };
    return { filters, columns, paging };
};

const changePageFromConstructor = () => {
    changePage(0);
    if (tableComp.value) {
        tableComp.value.scrollToTop();
    }
};

const changePage = (value: number) => {
    offset.value = value;
    getReport();
};

// -- Export
const isExportLoading = ref(false);
const exportEvents = async () => {
    try {
        isExportLoading.value = true;
        const params = getParams(true);
        const file = await getEventTraces(params, true);
        const period = [route.query.event_date_from ?? '', route.query.event_date_to ?? ''];
        const name = `Event tracer_${period[0]}_${period[1]}`;
        downloadExcelFile(file, name, 'csv', true);
    } catch (err) {
        showServerError(err, 'Не удалось скачать выгрузку');
    } finally {
        isExportLoading.value = false;
    }
};

return { __sfc: true,getHeaders, items, total, offset, isLoading, constructor, tableComp, filterClass, route, isDisableGetReport, getReport, getParams, changePageFromConstructor, changePage, isExportLoading, exportEvents, ListLayout, DownloadButton, ReloadButton, BaseTable, EventTracerConstructor }
}

})